import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask700To799Service {

  constructor() { }
}
